import { render, staticRenderFns } from "./arrowAnima.vue?vue&type=template&id=dacab98c&scoped=true&"
import script from "./arrowAnima.vue?vue&type=script&lang=js&"
export * from "./arrowAnima.vue?vue&type=script&lang=js&"
import style0 from "./arrowAnima.vue?vue&type=style&index=0&id=dacab98c&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacab98c",
  null
  
)

export default component.exports